<template>
  <div class="search" :class="[loading ? 'searching' : '']">
    <input
      class="input"
      contenteditable
      v-model.trim="input"
      :placeholder="placeholder"
      @keyup.enter="search"
    />
    <div
      class="icon"
      :class="[input ? 'input' : '']"
      :title="input ? '搜索' : placeholder"
    >
      <span class="iconfont icon-search-copy stage" @click="search()"></span>
      <span class="iconfont icon-arrwo go" @click="search()"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索词',
    },
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: '',
    };
  },
  watch: {
    value() {
      this.input = this.value;
    },
  },
  created() {
    this.input = this.value;
  },
  mounted() {
    if (this.focus) {
      this.$el.querySelector('input').focus();
    }
  },
  methods: {
    search() {
      if (this.loading) return this.$toast.warn('数据正在加载，请稍后');
      if (!this.input) return this.$toast.error(this.placeholder);
      this.$emit('input', this.input);
      this.$emit('change', this.input);
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  max-width: 100%;
  width: 600px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(92, 92, 92, 0.1);
  border-radius: 0;
  padding: 10px;
  box-shadow: 2px 0px 120px -6px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  .input {
    flex: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    border: none;
    background: transparent;
    &:focus,
    &:focus:active {
      outline: none;
    }
  }
  .icon {
    width: 20%;
    height: 100%;
    width: 40px;
    max-width: 40px;
    min-width: 40px;
    position: relative;
    .go,
    .stage {
      transition: transform 0.2s ease-in-out;
      width: 40px;
      height: 40px;
      display: inline-flex;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
    }
    .go {
      transform: rotateX(90deg);
    }
    .stage {
      transform: rotateX(0);
    }
    &.input:hover {
      .go {
        transform: rotateX(0);
      }
      .stage {
        transform: rotateX(90deg);
      }
    }
  }
  &.searching::after {
    content: '';
    display: block;
    width: 30%;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #99ec73;
    border-radius: 50%;
    animation: searching 0.6s linear infinite;
  }
}

@keyframes searching {
  0% {
    left: 0;
  }
  100% {
    left: 100%;
  }
}
</style>